import { PRIORITY_FIELD_OPTIONS } from '../const';
import { SupportFormSelectField } from './SupportFormSelectField';

export const PriorityField = () => (
  <SupportFormSelectField
    name="priority"
    label="Priority"
    selectProps={{
      options: Object.values(PRIORITY_FIELD_OPTIONS),
      placeholder: 'Select a priority',
    }}
  />
);
